
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    setCard() {
      let card = {}

      switch (this.blok.variant) {
        case 'organization':
          card = this.blok.organization_card[0]
          break
        case 'builder':
          card = this.blok.builder[0]
          break
        default:
      }

      return card
    },
  },
}
